import { render, staticRenderFns } from "./addMajor.vue?vue&type=template&id=61d01750"
import script from "./addMajor.vue?vue&type=script&lang=js"
export * from "./addMajor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61d01750')) {
      api.createRecord('61d01750', component.options)
    } else {
      api.reload('61d01750', component.options)
    }
    module.hot.accept("./addMajor.vue?vue&type=template&id=61d01750", function () {
      api.rerender('61d01750', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/webSet/basic/addMajor.vue"
export default component.exports